<template functional>
  <div>
    <a
      href="#"
      @click="$options.show(props)"
      :class="[props.row.CxP_Diff >= 0 ? 'Negro' : 'Rojo']"
      >{{ $options.formatMonto(props.row.CxP_Diff) }}</a
    >
  </div>
</template>

<script>
//import store from "../../../../store/index";
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperlinkForCxC_DiferenceDetail",
  show(ops) {
    ops;
    //console.log("hola", ops)
    ops.row.OpenDetailCxCDiference(ops.row);
  }
};
</script>
<style>
.Negro {
  color: #606266;
}
</style>
